module.exports = __webpack_public_path__ + "resources/img/img_akamaiAAP_m_en.7956bb30a0a8f17289334a99e298a280.png";